import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1da2abc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Breadcrumbs")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" How you got to  ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("  through the knowledge graph ")

import { watch } from "vue";
import { useRoute } from "vue-router";
import { breadcrumbs, updateBreadcrumbs } from "@/global/breadcrumbs";
import { Node } from "@/api/node-lookup";
import AppNodeBadge from "@/components/AppNodeBadge.vue";
import AppRelationBadge from "@/components/AppRelationBadge.vue";

interface Props {
  /** current node */
  node: Node;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SectionBreadcrumbs',
  props: {
    node: null
  },
  setup(__props: any) {



/** route info */
const route = useRoute();

/** keep breadcrumbs global variable in sync with history.state.breadcrumbs */
watch(() => route, updateBreadcrumbs, { immediate: true, deep: true });

/** clear breadcrumbs history */
function clear() {
  /**
   * confirmation warning not necessary since back button should return to
   * previous state
   */
  window.history.pushState({}, "");
  updateBreadcrumbs();
}

return (_ctx: any,_cache: any) => {
  const _component_AppHeading = _resolveComponent("AppHeading")!
  const _component_AppFlex = _resolveComponent("AppFlex")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppSection = _resolveComponent("AppSection")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_unref(breadcrumbs).length)
    ? (_openBlock(), _createBlock(_component_AppSection, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_AppHeading, { icon: "location-dot" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _hoisted_2,
            _createVNode(AppNodeBadge, {
              node: __props.node,
              link: false
            }, null, 8, ["node"]),
            _hoisted_3
          ]),
          _createVNode(_component_AppFlex, {
            direction: "col",
            gap: "small"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(breadcrumbs), (breadcrumb, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _createVNode(AppNodeBadge, {
                    node: breadcrumb.node,
                    onClickCapture: _withModifiers(($event: any) => (_ctx.$router.go(-_unref(breadcrumbs).length + index)), ["prevent"])
                  }, null, 8, ["node", "onClickCapture"]),
                  _createVNode(AppRelationBadge, {
                    relation: breadcrumb.relation,
                    vertical: true
                  }, null, 8, ["relation"])
                ], 64))
              }), 128)),
              _createVNode(AppNodeBadge, {
                node: __props.node,
                link: false
              }, null, 8, ["node"])
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(_component_AppButton, {
            icon: "times",
            text: "Clear",
            design: "small",
            onClick: clear
          }, null, 512), [
            [_directive_tooltip, 'Clear breadcrumb history']
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})